module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-body__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "c-history-list"
  }, [_c('ul', {
    staticClass: "c-history-list__list"
  }, _vm._l((_vm.history), function(item) {
    return _c('li', {
      staticClass: "c-history-list__item"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('span', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body__title"
  }, [_c('h2', [_vm._v("更新履歴")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5681724","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/page/history.vue
// module id = 70
// module chunks = 0